import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import scroll_45to_45top_45global from "/app/middleware/scroll-to-top.global.ts";
export const globalMiddleware = [
  validate,
  scroll_45to_45top_45global
]
export const namedMiddleware = {}